import { TFunction } from "i18next";
import * as Yup from "yup";

import { exchangeAppointmentSelectionRules, exchangeRequestedServicesRules } from "@/pages/exchange/Exchange.utils";

import { NewExchangeRequestFormValues } from "./NewExchangeRequestDialog.types";

export function newExchangeRequestValidationSchema(t: TFunction): Yup.ObjectSchema<NewExchangeRequestFormValues> {
  return Yup.object({
    ...exchangeAppointmentSelectionRules(t, t("exchange.newRequestDialog.from"), t("exchange.newRequestDialog.till")),
    ...exchangeRequestedServicesRules(t),
  });
}
